import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from './Variables.js';
import { FALSE } from 'sass';

export default function WhatsnewHome() {

  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();
  const JsonUrlWhatsnew = variables.basename_url + 'updates/index/Athlethixnet_HomeEn_TrendingNews.json';

  async function refda() {
    Get_Data_WhatsNew();

  }

  useEffect(() => {
    setNisLoading(true);
    refda();
  }, [])

  const [JsonWhatsNewArray, setJsonJsonWhatsNewArray] = React.useState([]);

  async function Get_Data_WhatsNew() {
    JsonWhatsNewArray.splice(0);  //to clear All data in your page
    setNisLoading(true);
    axios.get(JsonUrlWhatsnew)
      .then(function (response) {
        setNisLoading(false);
        console.log(response.data);
        for (let i = 0; i < 5 && i < response.data.length; i++) {
          JsonWhatsNewArray.push({
            Title: response.data[i].Title,
            news_date: response.data[i].news_date.split(" ")[0],
            Image: response.data[i].Image,
            link: response.data[i].link,
            Category: response.data[i].Category
          })
        }
      })
  };

  return (
    <>
      <div className="most-view-box mt-3">
        <div className="section-title">
          <h3 className="title">What’s New</h3>
        </div>
        <div className="trending-sidebar-slider slick-initialized slick-slider">
          <div className="slick-list draggable">
            <div className="slick-track">
              <div className="post_gallery_items slick-slide slick-current slick-active" data-slick-index={0} aria-hidden="false" tabIndex={0}>

                {JsonWhatsNewArray.map(da => (
                  <div key={da.Title}>
                    <div className="post-gallery-style-2 most-view-style-2">
                      <div className="post-gallery-thumb">
                        <Link to={da.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            className='rounded'
                            style={{ maxWidth: '85px', minWidth: '85px', maxHeight: '57px', minHeight: '57px' }}
                            src={da.Image}
                            alt="gallery"
                          />
                        </Link>
                      </div>
                      <div className="post-gallery-content pl-4">
                        <h5 className="title">
                          <Link to={da.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            tabIndex={-1}>
                            {da.Title}
                          </Link>
                        </h5>
                        <div className="meta-post-2-style">
                          <div className="meta-post-categores">
                            <Link to={da.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              tabIndex={-1}>
                              {da.Category}
                            </Link>
                          </div>
                          <div className="meta-post-date">
                            <span>{da.news_date}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Start line between news */}
                    <div></div>
                    {/* End line between news */}
                  </div>
                ))}

              </div>
              <div className="post_gallery_items slick-slide slick-cloned" data-slick-index={3} aria-hidden="true" tabIndex={-1} style={{ width: '300px' }}>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}



